import React from 'react';
import omit from 'lodash/omit';

import { Field } from 'formik';

import FormField from './FormField.jsx';

const FormRadioField = (props) => {
  const { radio } = props;

  return (
    <div className="input-group">
      <div className="input-group-prepend">
        <div className="input-group-text">
          <Field type="radio" {...radio} />
        </div>
      </div>
      <FormField {...omit(props, 'radio')} />
    </div>
  );
};

export default FormRadioField;
